import React from "react"
import { Link } from "gatsby"
import { useIntl, FormattedMessage } from "react-intl"
import { useFeatureStories, useIsLangEN } from "../hooks"
import classnames from "classnames"

const StoryLink = ({ featureStory, baseSlug }) => {
  const intl = useIntl()
  const isLangEN = useIsLangEN()
  const featureStories = useFeatureStories()
  return (
    <Link
      key={featureStory.baseSlug}
      to={`/${intl.locale}/${featureStory.baseSlug}/`}
      title={intl
        .formatMessage({ id: featureStory.title })
        .replace("<br/>", "")}
      className={classnames({
        "feature-story-navbar__link": true,
        "feature-story-navbar__link--en": isLangEN,
        "feature-story-navbar__link--is5": featureStories.length === 5,
        "feature-story-navbar__link--active":
          baseSlug === featureStory.baseSlug,
      })}
      activeClassName="feature-story-navbar__link--active"
      dangerouslySetInnerHTML={{
        __html: intl.formatMessage({ id: featureStory.title }),
      }}
    ></Link>
  )
}

const FeatureStoryNavbar = ({ baseSlug }) => {
  const featureStories = useFeatureStories()
  const intl = useIntl()
  const isLangEN = useIsLangEN()
  console.log("featureStories!?!?!?", featureStories)
  return (
    <div
      className={classnames({
        "feature-story-navbar": true,
        "feature-story-navbar--en": isLangEN,
        "feature-story-navbar--is5": featureStories.length === 5,
        "feature-story-navbar--is5--en":
          featureStories.length === 5 && isLangEN,
      })}
    >
      {featureStories.map(featureStory => (
        <StoryLink featureStory={featureStory} baseSlug={baseSlug}></StoryLink>
      ))}
    </div>
  )
}

export default FeatureStoryNavbar
